module.exports = __webpack_public_path__ + "static/avatar-b8d6d25feaeadf52759108dd9588bb0b.jpeg";